/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceGeneratePDFBufferRequest
 */
export interface InvoiceGeneratePDFBufferRequest {
    /**
     * 
     * @type {string}
     * @memberof InvoiceGeneratePDFBufferRequest
     */
    invoiceData: string;
}

/**
 * Check if a given object implements the InvoiceGeneratePDFBufferRequest interface.
 */
export function instanceOfInvoiceGeneratePDFBufferRequest(value: object): value is InvoiceGeneratePDFBufferRequest {
    if (!('invoiceData' in value) || value['invoiceData'] === undefined) return false;
    return true;
}

export function InvoiceGeneratePDFBufferRequestFromJSON(json: any): InvoiceGeneratePDFBufferRequest {
    return InvoiceGeneratePDFBufferRequestFromJSONTyped(json, false);
}

export function InvoiceGeneratePDFBufferRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceGeneratePDFBufferRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceData': json['invoiceData'],
    };
}

export function InvoiceGeneratePDFBufferRequestToJSON(json: any): InvoiceGeneratePDFBufferRequest {
    return InvoiceGeneratePDFBufferRequestToJSONTyped(json, false);
}

export function InvoiceGeneratePDFBufferRequestToJSONTyped(value?: InvoiceGeneratePDFBufferRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceData': value['invoiceData'],
    };
}

